import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class IncometaxService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  TaxCategoryMasterInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxCategoryMasterInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxCategoryMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxCategoryMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSlabMasterInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSlabMasterInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSlabMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSlabMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSectionFYMaster_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSectionFYMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSectionFYMasterSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSectionFYMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //need to remove
  TaxSectionMasterSelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSectionMasterSelect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSubSectionFYMaster_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSubSectionFYMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxSectionDetail_SelectLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxSectionDetail_Select/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxPreviousEmploymentDetailsLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxPreviousEmploymentDetails/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TaxPreviousEmploymentDetailsInsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `TaxPreviousEmploymentDetailsInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxDeclaration_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxDeclaration_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxDeclarationSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxDeclaration/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxDeclarationUpdateAtApproval(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxDeclarationUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpTaxInvestmentSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxInvestment/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }


  ESS_EmpTaxInvestment_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpTaxInvestment_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxInvestmentUpdateAtApproval(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxInvestmentUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxSubSectionMasterSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxSubSectionMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxCompareBACK(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxCompare/BACK`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxCompare_FRONT(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTax/Compare_FRONT`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxSummaryDetails_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxSummaryDetails_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_IncomeTaxSummaryDetailsSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_IncomeTaxSummaryDetails/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxFinancialYearSelect(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxFinancialYear/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TaxFinancialYear_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_TaxFinancialYear_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GenerateTDSReport(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `GenerateTDS/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}